import { Link } from "react-router-dom";

export default function HomeContentSections({ content, platforms = [] }) {
  const sections = [...(content?.sections || [])]
    .filter((section) => section.visible !== false)
    .sort((a, b) => (a.order || 0) - (b.order || 0));
  const faqs = [...(content?.faqs || [])]
    .filter((item) => item.visible !== false && item.question?.trim() && item.answer?.trim())
    .sort((a, b) => (a.order || 0) - (b.order || 0));
  const activePlatforms = platforms.filter((platform) => platform.enabled && platform.supported !== false && platform.slug);

  return (
    <div className="aran-card space-y-10 p-5 sm:p-8 lg:p-10" data-testid="home-editorial-content">
      {sections.map((section) => (
        <section key={section.id} className="space-y-4" aria-label={section.title} data-testid={`home-content-section-${section.id}`}>
          <h2 className="font-head text-xl sm:text-2xl font-bold">{section.title}</h2>
          {section.paragraphs?.filter((paragraph) => paragraph.trim()).map((paragraph, index) => (
            <p key={`${section.id}-paragraph-${index}`} className="leading-8 text-muted-foreground">{paragraph}</p>
          ))}
          {section.kind === "platforms" && (activePlatforms.length > 0 ? (
            <ul className="flex flex-wrap gap-3">
              {activePlatforms.map((platform) => <li key={platform.key}><Link className="inline-flex rounded-full border border-primary/30 bg-primary/5 px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring" to={`/${platform.slug}`}>{platform.name}</Link></li>)}
            </ul>
          ) : <p className="text-sm text-muted-foreground">ستظهر روابط الأدوات المتاحة عند تحميل إعدادات الموقع.</p>)}
        </section>
      ))}

      {faqs.length > 0 && <section className="space-y-4" aria-labelledby="home-faq-title" data-testid="home-faq-section">
        <h2 id="home-faq-title" className="font-head text-xl sm:text-2xl font-bold">{content.faq_title || "أسئلة شائعة"}</h2>
        <div className="grid gap-3 md:grid-cols-2">
          {faqs.map((item) => <article key={item.id} className="rounded-xl border border-border bg-background/40 p-4 sm:p-5">
            <h3 className="font-semibold leading-7">{item.question}</h3>
            <p className="mt-2 text-sm leading-7 text-muted-foreground">{item.answer}</p>
          </article>)}
        </div>
      </section>}

      <nav className="flex flex-wrap gap-x-5 gap-y-3 border-t border-border pt-6 text-sm font-semibold" aria-label="روابط مفيدة">
        <Link to="/learn" className="text-primary hover:underline">المكتبة التعليمية</Link>
        <Link to="/faq" className="text-primary hover:underline">مركز الأسئلة الشائعة</Link>
        {activePlatforms.slice(0, 3).map((platform) => <Link key={`footer-${platform.key}`} to={`/${platform.slug}`} className="text-primary hover:underline">أداة {platform.name}</Link>)}
      </nav>
    </div>
  );
}
